import { GetTogglesRequest } from '@eggplant/api-requests'
import type { ReactElement } from 'react'
import type { TogglesResponse } from '@eggplant/types'

interface Props {
  children: ReactElement
}

const Toggles = ({
  children
}: Props) =>
  <GetTogglesRequest>
    {
      (data: TogglesResponse) =>
        data.deployment_flags.ENABLE_DAI_CLOUD_SUT &&
          children
    }
  </GetTogglesRequest>

export default Toggles
